import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CampaignsListComponent } from './list/list.component';
import { Campaign } from '../../types/campaigns.models';

@Component({
    selector: 'don-campaign',
    imports: [CommonModule, CampaignsListComponent],
    templateUrl: './campaign.component.html',
    styleUrls: ['./campaign.component.scss']
})
export class CampaignComponent {
  @Input() campaigns: Campaign[] | null = [];
  @Input() selectedId: string | null = null;
  @Output() select = new EventEmitter<string>();
}
